module.exports = __webpack_public_path__ + "img/game4.f337c1cb.png";